import React, { useState } from 'react';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { TESTIMONIALS } from '../mock';

const Testimonials = () => {
  const [i, setI] = useState(0);
  const prev = () => setI((v) => (v - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setI((v) => (v + 1) % TESTIMONIALS.length);

  return (
    <section className="py-24 bg-[#f6f9fc]">
      <div className="max-w-[900px] mx-auto px-6 text-center">
        <p className="eyebrow mb-3">TESTIMONIALS</p>
        <h2 className="section-title text-3xl md:text-4xl mb-12">What Our Investors Say</h2>

        <div className="testimonial-card relative">
          <Quote className="absolute -top-6 left-1/2 -translate-x-1/2 bg-[#0a6cb0] text-white p-3 rounded-full" size={44} />
          <p className="text-[#0a2c4d] text-xl md:text-2xl font-serif-display italic leading-relaxed mt-4 mb-6">
            “{TESTIMONIALS[i].text}”
          </p>
          <div>
            <p className="font-bold text-[#0a2c4d]">{TESTIMONIALS[i].name}</p>
            <p className="text-[#0a6cb0] text-sm tracking-wider">{TESTIMONIALS[i].role}</p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-4 mt-8">
          <button onClick={prev} className="social-ico" aria-label="Previous"><ChevronLeft size={16} /></button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <span key={idx} className={`h-2 rounded-full transition-all ${idx === i ? 'w-8 bg-[#0a6cb0]' : 'w-2 bg-[#c9d3e0]'}`} />
            ))}
          </div>
          <button onClick={next} className="social-ico" aria-label="Next"><ChevronRight size={16} /></button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
